module.exports = __webpack_public_path__ + "img/rebus.17dcd38e.png";